/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import OrgForm from './OrgForm';
import { getAllOrg } from '../../../../../../store/reducers/organization/organizationAction';
import { createOrg } from '../../../../../../services/organization/Organization';

const OrgCreation = ({ handleClose }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationName }) => {
        try {
            await createOrg({ organizationName })
            toast.success('Organization was registred successfully');
            handleClose();
            await dispatch(getAllOrg()).unwrap();

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Registration</Typography>
            <Formik
                initialValues={{
                    organizationName: ''
                }}
                validationSchema={Yup.object().shape({
                    organizationName: Yup.string().min(2).max(40).required('Organization Name is required.')
                })}
                onSubmit={(
                    values
                ) => {
                    handleSubmit(values)
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (

                    <OrgForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched}
                    />
                )}
            </Formik>
        </>
    )

}


export default OrgCreation;
